export default "__VITE_ASSET__Yr_dKg6w__"